/**
 * useImageFallback Hook
 * Handles image loading errors and provides fallback state
 * Prevents layout shift and provides graceful degradation
 */

import { useState, useCallback } from 'react'

interface UseImageFallbackReturn {
  isImageError: boolean
  handleImageError: () => void
  handleImageLoad: () => void
}

export const useImageFallback = (): UseImageFallbackReturn => {
  const [isImageError, setIsImageError] = useState(false)

  const handleImageError = useCallback(() => {
    setIsImageError(true)
  }, [])

  const handleImageLoad = useCallback(() => {
    setIsImageError(false)
  }, [])

  return {
    isImageError,
    handleImageError,
    handleImageLoad,
  }
}
